import { ReactElement } from 'react'
import { EditableDropdown } from '../../../components'
import { DropdownWrapper } from './subcomponents'
import { UserFilterProps } from './typings'
import strings from '../../../locale/en'
import { ROLE } from '../../../helpers/determineMenu'
import FlexWrapper from '../../../components/FlexWrapper'

const UserFilterSection = ({
  institueList,
  branchList,
  batchList,
  instituteValue,
  branchValue,
  batchValue,
  handleBatchSelect,
  handleBranchSelect,
  handleinstituteSelect,
  role
}: UserFilterProps): ReactElement => {
  const superAdminFilter = (
    <>
      <DropdownWrapper>
        <EditableDropdown
          dropdownList={institueList}
          handleSelect={handleinstituteSelect}
          placeholder={strings.menu.admin.instituteName}
          defaultValue={instituteValue}
        />
      </DropdownWrapper>
      <DropdownWrapper>
        <EditableDropdown
          dropdownList={branchList}
          isMultiChoice
          handleMultiSelect={handleBranchSelect}
          placeholder={strings.menu.admin.branchName}
          defaultValue={branchValue}
        />
      </DropdownWrapper>
    </>
  )

  const instituteAdminFilter = (
    <DropdownWrapper>
      <EditableDropdown
        dropdownList={branchList}
        isMultiChoice
        handleMultiSelect={handleBranchSelect}
        placeholder={strings.menu.admin.branchName}
        defaultValue={branchValue}
      />
    </DropdownWrapper>
  )

  return (
    <FlexWrapper>
      {role === ROLE.ADMIN && superAdminFilter}
      {role === ROLE.INSTITUTE_ADMIN && instituteAdminFilter}
      <DropdownWrapper>
        <EditableDropdown
          dropdownList={batchList}
          isMultiChoice
          handleMultiSelect={handleBatchSelect}
          placeholder={strings.menu.admin.batchName}
          defaultValue={batchValue}
        />
      </DropdownWrapper>
    </FlexWrapper>
  )
}

export default UserFilterSection
